import { useEffect } from 'react';
import { ToastAction } from '@/components/ui/toast';
import { useApp } from '@/hooks/use-app-context';
import { useToast } from '@/hooks/use-toast';
import { APP_UPDATED_EVENT } from './register-service-worker';

/**
 * A new build took over while the page was open. The page keeps working on
 * its own build (the previous precache is kept), so nothing reloads by
 * itself: a recording in progress is never cut. The person reloads when ready.
 */
export function AppUpdateListener() {
  const { t } = useApp();
  const { toast } = useToast();

  useEffect(() => {
    const onUpdate = () =>
      toast({
        title: t.offline.appUpdatedTitle,
        description: t.offline.appUpdatedDesc,
        action: (
          <ToastAction altText={t.offline.reload} onClick={() => window.location.reload()}>
            {t.offline.reload}
          </ToastAction>
        ),
      });
    window.addEventListener(APP_UPDATED_EVENT, onUpdate);
    return () => window.removeEventListener(APP_UPDATED_EVENT, onUpdate);
  }, [t, toast]);

  return null;
}
